import React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

export default function FinancePlaceholder({ title }: { title: string }) {
  return (
    <Grid container paddingLeft={2} paddingRight={2} sx={{ pt: 2 }}>
      <Grid item xs={12}>
        <Typography variant="h5" gutterBottom>
          {title}
        </Typography>
        <Typography variant="body1">Coming soon.</Typography>
      </Grid>
    </Grid>
  );
}
